document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.faq-accordion__trigger');
  if (!trigger) return;

  var item = trigger.closest('.faq-accordion__item');
  var section = trigger.closest('.faq-accordion');
  var answer = item.querySelector('.faq-accordion__answer');
  var isOpen = trigger.getAttribute('aria-expanded') === 'true';

  // Close all other items in this section (accordion behavior).
  // Delete this forEach block if you want multiple answers open at once.
  section.querySelectorAll('.faq-accordion__item').forEach(function (otherItem) {
    if (otherItem !== item) {
      otherItem.classList.remove('is-open');
      otherItem.querySelector('.faq-accordion__trigger').setAttribute('aria-expanded', 'false');
      otherItem.querySelector('.faq-accordion__answer').style.maxHeight = null;
    }
  });

  if (isOpen) {
    trigger.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    answer.style.maxHeight = null;
  } else {
    trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
});
